<p-panel
  header="{{
    'POLITICAS.LBL_CONFIGURACIONGENERAL' | translate
  }}"
>
  <app-loading *ngIf="carInformacionInicial"></app-loading>
  <div *ngIf="!carInformacionInicial">
    <form [formGroup]="formulario">
      <div class="grid form-group">
        <!-- CODIGO -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label for="codigo"
              >* {{ "POLITICAS.LBL_CODIGO" | translate }}</label
            >
            <div *ngIf="!politica">
              <input
                type="text"
                pInputText
                id="codigo"
                name="nomCodigo"
                autocomplete="off"
                formControlName="codigo"
                maxlength="10"
                (blur)="validarCodigo()"
                codigos-reactive
              />
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.codigo.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_CODIGO" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="codExiste"
              >
                {{ "POLITICAS.MSG_CODIGOEXISTE" | translate }}
              </div>
            </div>
            <div *ngIf="politica && politica?.idPolitica">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.codigo }}</label
              >
            </div>
          </div>
        </div>

        <!-- NOMBRE -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label for="nombre"
              >* {{ "POLITICAS.LBL_NOMBRE" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <input
                type="text"
                pInputText
                id="nombre"
                name="nomCodigo"
                autocomplete="off"
                formControlName="nombre"
                maxlength="120"
              />
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.nombre.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_NOMBRE" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.nombre }}</label
              >
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <!-- CATEGORIA POLITICA -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label for="idCategoriaPolitica"
              >* {{ "POLITICAS.LBL_CATEGORIA" | translate }}</label
            >
            <div *ngIf="!politica">
              <p-dropdown disableTab
                id="idCategoriaPolitica"
                [options]="listaCategoriasPoliticas"
                formControlName="idCategoriaPolitica"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                 (onChange)="validarCampos()"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idCategoriaPolitica.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_CATEGORIA" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="politica && politica?.idPolitica">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.categoriaPolitica }}</label
              >
            </div>
          </div>
        </div>

        <!-- VINCULACION -->
        <div class="col-12 md:col-6 lg:col-6" *ngIf="!politicaReglasParticipantes && !politicaReglasTalanquera">
          <div class="div-form">
            <label for="vinculaciones"
              >* {{ "POLITICAS.LBL_VINCULACION" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <p-multiSelect
                id="vinculaciones"
                name="nomVinculaciones"
                [options]="lisVinculaciones"
                defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
                selectedItemsLabel="{0} {{
                  'LBL_ELEMENTOSSELECCIONADOS' | translate
                }}"
                formControlName="idsVinculaciones"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idsVinculaciones.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_VINCULACION" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.vinculaciones }}</label
              >
            </div>
          </div>
        </div>

        <!-- TIPO DE PRODUCTO BANCARIO -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label for="idsTipoProducto">* {{ "POLITICAS.LBL_TIPO_PRODUCTO" | translate }}</label>
            <div *ngIf="!esDetalle">
              <p-multiSelect
                id="idsTipoProducto"
                name="idsTipoProducto"
                [options]="selectTiposProductosBancarios"
                defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
                selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate }}"
                formControlName="idsTipoProducto"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTipoProducto.invalid">
                <i class="fa fa-close"></i>{{ "POLITICAS.LBL_TIPO_PRODUCTO" | translate }} {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">{{ politicas?.politica?.tipoProducto }}</label>
            </div>
          </div>
        </div>

      </div>

      <div class="grid form-group" *ngIf="politicasCredito && activar">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="politicasCredito">
          <div class="div-form">
            <div>
              <p-checkbox
                label="{{ 'POLITICAS.LBL_SEGUNPERFIL' | translate}}" binary="false"
                id="SegunPerfilRiesgo" (click)="validarSegunPerfil(false)"
                name="SegunPerfilRiesgo"
                formControlName="indicadorPerfilRiesgo" [disabled]="esDetalle"
              ></p-checkbox>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-6" *ngIf="activar">
          <div class="div-form" style="margin-top: 5px">
            <label for="vinculaciones">
              * {{ "POLITICAS.LBL_PERFILRIESGO" | translate }}
            </label>
            <div *ngIf="!esDetalle">
              <p-multiSelect
                id="idPerfilRiesgo"
                [options]="lisPerfiles"
                (onChange)="matchPerfilesSeleccionados($event)"
                formControlName="idPerfilRiesgo"
                filter="filter"
                defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idPerfilRiesgo.invalid">
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_PERFILRIESGO" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politicasPerfilRiesgo?.perfilRiesgo }}</label
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Campos para las politicas tipo alerta  -->
      <div class="grid form-group" *ngIf="politicaAnteriores || politicaTipoAlerta && !politicaReglasParticipantes && !politicaReglasTalanquera" >
        <!-- PERFILES -->
        <div class="col-12 md:col-6 lg:col-6" *ngIf="politicaTipoAlerta">
          <div class="div-form">
            <label for="idPerfil"
            >* {{ "POLITICAS.LBL_PERFILES" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <p-multiSelect
                id="idPerfil"
                name="Perfil"
                [options]="lisPerfiles"
                defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
                selectedItemsLabel="{0} {{
                  'LBL_ELEMENTOSSELECCIONADOS' | translate
                }}"
                formControlName="idPerfil"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idPerfil.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_PERFILES" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="valPerNota"
              >
                {{ "POLITICAS.MSG_PERFILNOTA" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <div *ngIf="esDetalle">
                <label class="falso-combo-texto">{{ politicas?.politica?.perfiles }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- TIPO ALERTA -->
        <div class="col-12 md:col-6 lg:col-6" *ngIf="politicaAnteriores || politicaTipoAlerta">
          <div class="div-form">
            <label for="idTipoAlerta"
            >* {{ "POLITICAS.LBL_TIPOALERTA" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <p-dropdown disableTab
                id="idTipoAlerta"
                [options]="lisTipoAlerta"
                formControlName="idTipoAlerta"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idTipoAlerta.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_TIPOALERTA" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>



            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">{{ politicas?.politica?.alerta }}</label>
            </div>
          </div>
        </div>

        <!-- NOTA -->
        <div class="col-12 md:col-6 lg:col-6" *ngIf="politicaTipoAlerta">
          <div class="div-form">
            <label for="nota"
            >* {{ "POLITICAS.LBL_NOTA" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <p-dropdown disableTab
                id="nota"
                [options]="lisNota"
                formControlName="nota"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.nota.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_NOTA" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.nota }}</label
              >
            </div>
          </div>
        </div>

        <!-- OFICINAS -->
        <div class="col-12 md:col-6 lg:col-6" *ngIf="politicaTipoAlerta">
          <div class="div-form">
            <label for="idPerfil"
            >* {{ "POLITICAS.LBL_OFICINAS" | translate }}</label
            >
            <div *ngIf="!esDetalle">
              <p-multiSelect
                id="idOficinas"
                name="idOficinas"
                [options]="lisOficinas"
                defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
                selectedItemsLabel="{0} {{
                  'LBL_ELEMENTOSSELECCIONADOS' | translate
                }}"
                formControlName="idOficinas"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idOficinas.invalid"
              >
                <i class="fa fa-close"></i
                >{{ "POLITICAS.LBL_OFICINAS" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <div *ngIf="esDetalle">
                <label class="falso-combo-texto">{{ politicas?.politica?.oficinas }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group" *ngIf="politicaAnteriores || politicaTipoAlerta || politicaPreselecta || politicasCredito">
        <div [ngClass]="{'col-12 md:col-12 lg:col-12': !politicasCredito, 'col-6 md:col-6 lg:col-6': politicasCredito}">
          <div class="div-form">
            <label>* {{ 'POLITICAS.LBL_DESCRIPCION' | translate }}</label>
            <div *ngIf="!esDetalle">
              <textarea pInputTextarea type="text" pInputText id="descripcion"
                        name="descripcion"
                        autocomplete="off"
                        formControlName="descripcion"
                        rows="4" [sinComa]="false"
                        appTexto [sinEspacio]="false" [sinCaracteres]="false" [sinNumeros]="false" [sinPunto]="false"
                        [maxlength]="500"
              ></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                {{ 'POLITICAS.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.descripcion }}</label
              >
            </div>
          </div>
        </div>
        <div class="grid col-6 md:col-6 lg:col-6" *ngIf="politicasCredito">
          <div class="div-form col" style="margin-top: 15px;">
            <p-checkbox label="{{ 'POLITICAS.LBL_EJECUCIONINDIVIDUAL' | translate}}" binary="true"
                        id="indicadorEjecucionIndividual" (onChange)="validarCheckPoliticaRetanqueo($event)"
                        name="nomEjecucionIndividual"
                        formControlName="indicadorEjecucionIndividual" [disabled]="esDetalle"></p-checkbox>
          </div>
          <div class="div-form col" style="margin-top: 15px;">
            <p-checkbox label="{{ 'POLITICAS.LBL_INDPLATAFORMA' | translate}}" binary="true"
                        id="idindicadorPlataforma"
                        name="nomindicadorPlataforma"
                        formControlName="indicadorPlataformaDigital" [disabled]="esDetalle"></p-checkbox>
          </div>
        </div>
      </div>

      <div class="grid form-group" *ngIf="politicaPreselecta">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="div-form">
            <label>* {{ 'POLITICAS.LBL_RESPUESTA' | translate }}</label>
            <div *ngIf="!esDetalle">
              <textarea pInputTextarea type="text" pInputText id="respuesta"
                        name="respuesta"
                        autocomplete="off"
                        formControlName="respuesta"
                        appTexto [sinEspacio]="false" [sinCaracteres]="false" [sinNumeros]="false" [sinPunto]="false"
                        [maxlength]="500"
                        rows="4"
              ></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.respuesta.invalid">
                {{ 'POLITICAS.LBL_RESPUESTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <div *ngIf="esDetalle">
              <label class="falso-combo-texto">
                {{ politicas?.politica?.respuesta }}</label
              >
            </div>
          </div>
        </div>
      </div>

      <!-- HABILITADO -->
      <div class="grid form-group"  *ngIf="politicaReglasTalanquera">
        <div class="col-12 md:col-4 lg:col-4 col-">
          <p-checkbox label="{{ 'POLITICAS.LBL_HABILITADO' | translate}}" binary="true"
                      id="indicadorHabilitado"
                      name="nomHabilitado"
                      formControlName="indicadorHabilitado" [disabled]="esDetalle"></p-checkbox>
        </div>
      </div>

      <!-- CHECK OFICINAS POLCRE-->
      <p-fieldset legend="{{ 'POLITICAS.LBL_OFICINAS' | translate }}" *ngIf="politicasCredito">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid col-12 form-group" style="align-items: center">
              <div class="col-4 md:col-4 lg:col-4">
                <div class="div-form">
                  <div>
                    <p-checkbox label="{{ 'POLITICAS.LBL_POROFICINAS' | translate}}" binary="true"
                                id="indicadorOficinaPolcre"
                                name="nomOficina"
                                formControlName="indicadorOficina" [disabled]="esDetalle"></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-6 md:col-6 lg:col-6" *ngIf="f.indicadorOficina.value && !esDetalle">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_OFICINA' | translate }}</label>
                  <p-multiSelect id="idOficinasPolcre" name="nomOficinasDescarte" [options]="lisOficinas" filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idOficinasPolcre"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-2 md:col-2 lg:col-2 pt-5" *ngIf="f.indicadorOficina.value && !esDetalle" >
                <div *ngIf="!guardando">
                  <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton (click)="agregarOficinaPolcre()"></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12" *ngIf="f.indicadorOficina.value">
            <app-loading *ngIf="guardando"></app-loading>
            <!-- BUSCADOR DATATABLE PARAMETROS -->
            <div class="grid" *ngIf="!guardando">
              <div class="col-12 md:col-6 lg:col-6">
                <input
                  type="text"
                  pInputText
                  #gb
                  size="40"
                  placeholder="{{ 'LBL_BUSCAR' | translate }}"
                  (input)="tablePolcre.filterGlobal($event.target.value, 'contains')"
                />
              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <p-table [columns]="columnasOficinasPolcre" *ngIf="!guardando" #tablePolcre
                         [value]="listOficinasPolcre" selectionMode="single" dataKey="idPoliticaDescarteOficina"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.codigo}}</td>
                      <td>{{row.estructura}}</td>
                      <td class="text-center" *ngIf="!esDetalle">
                        <div class="btn-group" role="group">
                          <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                  title="{{'BTN_INHABILITAR' | translate}}" pButton
                                  (click)="inhabilitarOficinasPolcre(row)"></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <div class="div-form" style="margin: 5px" *ngIf="politicasCredito && f.indicadorOficina.value && listOficinasPolcre.length === 0 && submitted">
                  <div class="p-message p-messages-error p-corner-all">
                    {{ 'POLITICAS.LBL_OFICINAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- CHECK REGLA DE RETANQUEO -->
      <p-fieldset legend="{{ 'POLITICAS.LBL_RETANQUEO' | translate }}" *ngIf="politicasCredito">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid col-12 form-group" style="align-items: center">
              <div class="col-4 md:col-4 lg:col-4">
                <div class="div-form">
                  <div>
                    <p-checkbox
                      label="{{ 'POLITICAS.LBL_REGLADERETANQUETO' | translate}}" binary="false"
                      id="indicadorReglaRetanqueo" (onChange)="validarCheckEjecucionIndividual($event)"
                      name="indicadorReglaRetanqueo"
                      formControlName="indicadorReglaRetanqueo" [disabled]="esDetalle"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-6 md:col-6 lg:col-6" *ngIf="f.indicadorReglaRetanqueo.value && !esDetalle">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_OBLIGACIONESRECOGER' | translate }}</label>
                  <p-multiSelect id="idPoliticaRetanqueoProducto" name="nomPoliticaRetanqueoProducto" [options]="listaProductosPoliticasRetanqueo" filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                                 formControlName="idPoliticaRetanqueoProducto"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedProductosRetanqueo">
                    {{ 'POLITICAS.LBL_OBLIGACIONESRECOGER' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-2 md:col-2 lg:col-2 pt-5" *ngIf="f.indicadorReglaRetanqueo.value && !esDetalle" >
                <div *ngIf="!saveProductoRetanqueo">
                  <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton (click)="agregarProductoPoliticaRetanqueo()"></button>
                </div>
                <div *ngIf="saveProductoRetanqueo">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-12 md:col-12 lg:col-12" *ngIf="f.indicadorReglaRetanqueo.value">
              <app-loading *ngIf="saveProductoRetanqueo"></app-loading>
              <p-table [columns]="columnasProductosRetanqueo" *ngIf="!saveProductoRetanqueo"
                       [value]="productosPoliticasRetanqueo" selectionMode="single" dataKey="idPoliticaRetanqueoProducto"
                       [paginator]="true" [rows]="5"  paginatorPosition="bottom">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr [pSelectableRow]="row">
                    <td class="text-center">{{row.codigoProducto}}</td>
                    <td>{{row.producto}}</td>
                    <td class="text-center">{{row.productoModalidad}}</td>
                    <td *ngIf="!esDetalle" class="text-center">
                      <div class="btn-group" role="group">
                        <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                title="{{'BTN_INHABILITAR' | translate}}" pButton
                                (click)="inhabilitarProductoRetanqueo(row)"></button>

                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length">
                      {{ 'MSG_NOHAYREGISTROS' | translate}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="{{ 'POLITICAS.LBL_TIPOCREDITO' | translate }}" *ngIf="(politicaTipoAlerta || politicasCredito) && !politicaReglasParticipantes && !politicaReglasTalanquera">
        <div class="content col-12 flex">
          <div class="col-12 md:col-6 lg:col-6">
            <p-checkbox label="{{ 'POLITICAS.LBL_NUEVO' | translate}}" binary="true"
                        id="indicadorNuevo"
                        name="nomNuevo"
                        formControlName="indicadorNuevo" [disabled]="esDetalle"></p-checkbox>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <p-checkbox label="{{ 'POLITICAS.LBL_RENOVACION' | translate}}" binary="true"
                        id="indicadorRenovacion"
                        name="nomRenovacion"
                        formControlName="indicadorRenovacion" [disabled]="esDetalle"></p-checkbox>
          </div>
        </div>
      </p-fieldset>

      <app-politica-planteamiento-politica
          [centralizadaPoliticas]="politicas"
          [esDetalle]="esDetalle"
          *ngIf="politicasCredito"
          (actualizarPoliticaPlanteamientoPolitica)="updatePoliticas($event)"
          (planteamientosEditado)="politicaPlanteamientoPoliticaEditado()">
      </app-politica-planteamiento-politica>

      <div class="grid form-group" *ngIf="submitted && valCodicionesPolitica">
        <div class="div-form">
          <div
            class="p-message p-messages-error p-corner-all"
          >
            {{ "POLITICAS.MSG_CONDICIONESPOLITICA" | translate }}
          </div>
        </div>
      </div>

      <p-fieldset *ngIf="politicasCredito">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid form-group">

              <div class="col-12 md:col-4 lg:col-4 textCenter">
                <p-radioButton name="indicadorUsoPolitica" label="{{ 'POLITICAS.LBL_POLITICAGLOBAL' | translate}}" formControlName="indicadorUsoPolitica"
                               [value]="'Global'" (onClick)="validarTipoPolitica('Global')" [disabled]="esDetalle"></p-radioButton>
              </div>
              <div class="col-12 md:col-4 lg:col-4 textCenter">
                <p-radioButton name="indicadorUsoPolitica" label="{{ 'POLITICAS.LBL_POLITICAMODALIDAD' | translate}}" formControlName="indicadorUsoPolitica"
                               [value]="'Modalidad'" (onClick)="validarTipoPolitica( 'Modalidad')" [disabled]="esDetalle"></p-radioButton>
              </div>
              <div class="col-12 md:col-4 lg:col-4 textCenter">
                <p-radioButton name="indicadorUsoPolitica" label="{{ 'POLITICAS.LBL_POLITICAPRODUCTO' | translate}}" formControlName="indicadorUsoPolitica"
                               [value]="'Producto'" (onClick)="validarTipoPolitica( 'Producto')" [disabled]="esDetalle"></p-radioButton>
              </div>


              <div class="div-form">
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && valPolUniGen"
                >
                  {{ "POLITICAS.MSG_GENERALUNICA" | translate }}
                </div>
              </div>

            </div>
          </div>
          <div class="row col-12">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorPoliticaModalidad.value ">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_MODALIDAD' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-multiSelect id="idModalidadCredito" name="nomVinculacion" [options]="lisModalidades" filter="filter"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idModalidadCredito"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModalidadCredito.invalid">
                      {{ 'POLITICAS.LBL_MODALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.modalidad }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorPoliticaProducto.value && !esDetalle">
                <div class="div-form" >
                  <label>* {{ 'POLITICAS.LBL_PRODUCTO' | translate }}</label>
                  <p-multiSelect id="idProducto" name="nomVinculacion" [options]="lisProductos" filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idProducto"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>

                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedProductos">
                    {{ 'POLITICAS.LBL_PRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>

                </div>
              </div>

              <div class="col-4 md:col-4 lg:col-4" *ngIf="f.indicadorPoliticaProducto.value && !esDetalle" >
                <div *ngIf="!guardando">
                  <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton (click)="agregarProducto()"></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>



              <div class="col-12 md:col-12 lg:col-12" *ngIf="f.indicadorPoliticaProducto.value">
                <p-table [columns]="columnasProductos" *ngIf="!guardando"
                         [value]="listaPoliticaProducto" selectionMode="single" dataKey="idPoliticasProducto"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.codigoProducto}}</td>
                      <td>{{row.producto}}</td>
                      <td>{{row.modalidad}}</td>
                      <td *ngIf="!esDetalle">
                        <div class="btn-group" role="group">
                          <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                  title="{{'BTN_INHABILITAR' | translate}}" pButton
                                  (click)="inhabilitarProducto(row)"></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset *ngIf="politicasCredito">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label for="idCategoriaPolitica"
                  >* {{ "POLITICAS.LBL_IDENTIDICACIONPOLITICA" | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab
                      id="idIdentificacionPolítica"
                      [options]="lisTiposPolitica"
                      formControlName="idIdentificacionPolitica"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      (onChange)="tiposEjecucion()"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                    ></p-dropdown>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idIdentificacionPolitica.invalid"
                    >
                      <i class="fa fa-close"></i
                      >{{ "POLITICAS.LBL_IDENTIDICACIONPOLITICA" | translate }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.listaTipoEjecucionPolitica }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6" *ngIf="integracion && tipoProcesoTradicional">
                <div class="div-form">
                  <label for="idCategoriaPolitica"
                  >* {{ "POLITICAS.LBL_INTEGRACIONES" | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab
                      id="idIntegracion"
                      [options]="lisIntegracion"
                      formControlName="idIntegracion"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                    ></p-dropdown>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idIntegracion.invalid"
                    >
                      <i class="fa fa-close"></i
                      >{{ "POLITICAS.LBL_INTEGRACIONES" | translate }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.integracion }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6" *ngIf="paso && tipoProcesoTradicional">
                <div class="div-form">
                  <label for="idCategoriaPolitica"
                  >* {{ "POLITICAS.LBL_PASO" | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-multiSelect
                      id="idPaso"
                      [options]="lisFlujoVentaPaso"
                      defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
                      selectedItemsLabel="{0} {{'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                      formControlName="idPaso"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                    ></p-multiSelect>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idPaso.invalid"
                    >
                      <i class="fa fa-close"></i
                      >{{ "POLITICAS.LBL_PASO" | translate }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.flujo }}</label
                    >
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>
      </p-fieldset>

      <div class="grid" *ngIf="politicaReglasParticipantes">
        <div class="col-6">
          <app-politica-matriz [matrizGeneral]="true"  [politica]="politica" (listadoMatriz)="guardarMatrizTemporal($event, true)" [listadoVinculaciones]="listaVinculaciones" [matriz]="matrizGeneral" [esDetalle]="esDetalle"></app-politica-matriz>
        </div>
        <div *ngFor="let matriz of listadoMatricesModalidad; let i = index" class="col-6">
          <app-politica-matriz [matrizGeneral]="false"  [politica]="politica" [listadoVinculaciones]="listaVinculaciones" [matriz]="matriz" (eliminarMatriz)="eliminarMatriz(i)" (listadoMatriz)="guardarMatrizTemporal($event)" [esDetalle]="esDetalle"></app-politica-matriz>
        </div>
        <div class="col-6">
          <div class="matriz-select">
            <button type="button" pButton icon="fa fa-plus" label="{{ 'POLITICAS.LBL_AGREGARMODALIDAD' | translate }}" class="button-xl button-transparent" *ngIf="!formMatriz && !esDetalle" (click)="showFormMatriz()"></button>
            <div class="matriz-select-form" *ngIf="formMatriz">
              <div class="div-form">
                <label>* {{ 'POLITICAS.LBL_MODALIDAD' | translate }}</label>
                <div>
                  <p-dropdown disableTab
                    id="modalidadMatriz"
                    [options]="lisModalidades"
                    formControlName="modalidadMatriz"
                    placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                  ></p-dropdown>
                </div>
              </div>
              <button type="button" pButton icon="fa fa-plus" label="{{ 'LBL_AGREGAR' | translate }}" (click)="agregarMatriz()"></button>
            </div>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="politicaReglasTalanquera">
        <div class="col-12">
          <app-politica-talanquera [politica]="politica" [esDetalle]="esDetalle"></app-politica-talanquera>
        </div>
      </div>

      <p-fieldset legend="{{ 'POLITICADESCARTAR.LBL_DESCARTAR' | translate }}" *ngIf="!politicaReglasTalanquera">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'POLITICADESCARTAR.LBL_DESCARTAR' | translate}}" binary="true"
                            id="fDescarta"
                            name="nomDescarta"
                            formControlName="indicadorDescarta" (onChange)="validacionesDescartes()" [disabled]="esDetalle"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6" *ngIf="politicasCredito && f.indicadorDescarta.value">
                <p-checkbox label="{{ 'POLITICADESCARTAR.LBL_DENEGACIONAUTOMATICA' | translate}}" binary="true"
                            id="indicadorDeniegaAutomatico"
                            name="nomAutomatico"
                            formControlName="indicadorDenegacionAutomatica" [disabled]="esDetalle"></p-checkbox>
              </div>

              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'POLITICAS.LBL_POROFICINAS' | translate}}" binary="true"
                            id="indicadorOficina"
                            name="nomOficina"
                            formControlName="indicadorOficina" *ngIf="f.indicadorDescarta.value && politicaPreselecta" [disabled]="esDetalle"></p-checkbox>
              </div>

            </div>
          </div>
          <div class="row col-12">
            <div class="grid form-group" *ngIf="f.indicadorDescarta.value">

              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'POLITICADESCARTAR.LBL_VINCULACION' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-multiSelect id="idVinculacionDescarta" name="nomVinculacion" [options]="lisVinculaciones" filter="filter"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idVinculacionDescarta"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idVinculacionDescarta.invalid">
                      {{ 'POLITICADESCARTAR.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.descarteVinculacion }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'POLITICADESCARTAR.LBL_ESTADO' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab  id="idEstado" name="nomEstado" [options]="lisEstados"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="idEstado"
                    ></p-dropdown>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
                      {{ 'POLITICADESCARTAR.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>

                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.estado }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'POLITICADESCARTAR.LBL_CAUSAL' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab  id="idCausal" name="nomCausal" [options]="lisCausales"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="idCausal"
                    ></p-dropdown>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausal.invalid">
                      {{ 'POLITICADESCARTAR.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.causal }}</label
                    >
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div class="row col-12">
            <div class="grid form-group" *ngIf="f.indicadorDescarta.value && f.indicadorOficina.value && politicaPreselecta">

              <div class="col-12 md:col-6 lg:col-6" *ngIf="!esDetalle">
                <div class="div-form">
                  <label> * {{ 'POLITICAS.LBL_OFICINA' | translate }}</label>
                  <p-multiSelect id="idoficinasDescarte" name="nomOficinasDescarte" [options]="lisOficinas" filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idoficinasDescarte"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedOficinas">
                    {{ 'POLITICAS.LBL_OFICINA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>

              <div class="col-4 md:col-4 lg:col-4" *ngIf="!esDetalle">
                <div *ngIf="!guardando">
                  <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton (click)="agregarOficinas()"></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-12">
                <p-table [columns]="columnasOficinas" *ngIf="!guardando"
                         [value]="listaDescarteOficinas" selectionMode="single" dataKey="idPoliticaDescarteOficina"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.estructura}}</td>
                      <td *ngIf="!esDetalle">
                        <div class="btn-group" role="group">
                          <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                  title="{{'BTN_INHABILITAR' | translate}}" pButton
                                  (click)="inhabilitarOficinas(row)"></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="{{ 'POLITICAS.LBL_ALERTA' | translate }}" *ngIf="!politicaReglasTalanquera">
        <div class="content col-12">
          <div class="row col-12">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'POLITICAS.LBL_ALERTA' | translate}}" binary="true"
                            id="indicadorAlerta"
                            name="nomAlerta"
                            formControlName="indicadorAlerta" (onChange)="validacionesAlertas()" [disabled]="esDetalle"></p-checkbox>
              </div>

              <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorAlerta.value">
                <p-checkbox label="{{ 'POLITICAS.LBL_EXCEPCION' | translate}}" binary="true"
                            id="indicadorExcepcion"
                            name="nomAlerta"
                            formControlName="indicadorExcepcion" (onChange)="validacionesAlertasExcepcion()" [disabled]="esDetalle"></p-checkbox>
              </div>

              <div class="div-form">
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="valConDesAle"
                >
                  {{ "POLITICAS.MSG_DESCARTEALERTA" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6"  *ngIf="f.indicadorAlerta.value">
                <div class="div-form">
                  <label>* {{ 'POLITICADESCARTAR.LBL_VINCULACION' | translate }}</label>
                  <div *ngIf="!esDetalle">

                    <p-multiSelect id="idVinculacionAlerta" name="nomVinculacion" [options]="lisVinculaciones" filter="filter"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idVinculacionAlerta"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idVinculacionAlerta.invalid">
                      {{ 'POLITICADESCARTAR.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>

                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="valDesAle"
                    >
                      {{ "POLITICAS.MSG_VINCULACION" | translate }}
                    </div>
                  </div>

                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.alertaVinculacion }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2"  *ngIf="f.indicadorExcepcion.value">
                <p-checkbox label="{{ 'POLITICAS.LBL_MANEJAADJUNTO' | translate}}" binary="true"
                            id="indicadorManejaAdjunto"
                            name="nomAlerta" (onChange)="validarRequerirRespaldo()"
                            formControlName="indicadorManejaAdjunto" [disabled]="esDetalle"></p-checkbox>
              </div>

              <div class="col-12 md:col-4 lg:col-4"  *ngIf="habilitarRespaldo">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_ADJUNTO' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab  id="idRespaldo" name="nomRespaldo" [options]="listaRespaldos"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="idRespaldo"
                    ></p-dropdown>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idRespaldo.invalid">
                      {{ 'POLITICAS.LBL_ADJUNTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.respaldo }}</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6"  *ngIf="f.indicadorExcepcion.value">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_NIVELAPROBACION' | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-dropdown disableTab  id="idNivel" name="nomCausal" [options]="lisNiveles"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="idNivel"
                    ></p-dropdown>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivel.invalid">
                      {{ 'POLITICAS.LBL_NIVELAPROBACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.nivel }}</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-2 lg:col-2" *ngIf="politicasCredito && f.indicadorExcepcion.value">
                <p-checkbox label="{{ 'POLITICAS.LBL_APLICAROL' | translate}}" binary="true"
                            name="nomindicadorAplicaRol" (onChange)="validarRequeirirRoles()"
                            formControlName="indicadorAplicaRol" [disabled]="esDetalle"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4" *ngIf="f.indicadorAplicaRol.value && politicasCredito">
                <div class="div-form">
                  <label
                  >* {{ "POLITICAS.LBL_ROL" | translate }}</label>
                  <div *ngIf="!esDetalle">
                    <p-multiSelect id="idRoles" name="nomRoles" [options]="listaRoles"
                                   filter="filter"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                                   formControlName="idRol"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idRol.invalid"
                    >
                      <i class="fa fa-close"></i
                      >{{ "POLITICAS.LBL_ROL" | translate }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.roles }}</label
                    >
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-6"  *ngIf="f.indicadorAlerta.value">
                <p-checkbox label="{{ 'POLITICAS.LBL_APLICATASAMAXIMA' | translate}}" binary="true"
                            name="nomIndicadorTasaMaxima"
                            formControlName="indicadorTasaMaxima" [disabled]="esDetalle"></p-checkbox>
              </div>

              <div class="col-12 md:col-12 lg:col-12" *ngIf="f.indicadorExcepcion.value">
                <div class="div-form">
                  <label>* {{ 'POLITICAS.LBL_DEFINICIONEXCEPCION' | translate }}</label>
                  <div *ngIf="!esDetalle">
                <textarea pInputTextarea type="text" pInputText id="definicion"
                          name="definicion"
                          autocomplete="off"
                          formControlName="definicion"
                          appTexto [sinEspacio]="false" [sinCaracteres]="false" [sinNumeros]="false" [sinPunto]="false"
                          [maxlength]="200"
                ></textarea>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.definicion.invalid">
                      {{ 'POLITICAS.LBL_DEFINICIONEXCEPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="esDetalle">
                    <label class="falso-combo-texto">
                      {{ politicas?.politica?.definicion }}</label
                    >
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- HABILITADO -->
      <div class="grid form-group" *ngIf="!politicaReglasTalanquera">
        <div class="col-12 md:col-4 lg:col-4 col-">
          <p-checkbox label="{{ 'POLITICAS.LBL_HABILITADO' | translate}}" binary="true"
                      id="indicadorHabilitadoN"
                      name="nomHabilitado"
                      formControlName="indicadorHabilitado" [disabled]="esDetalle"></p-checkbox>
        </div>
      </div>
    </form>

    <div class="grid form-footer-buttons" *ngIf="!esDetalle">
      <div class="form-group col-12" *ngIf="!guardando">
        <a (click)="regresar(formulario.dirty)" class="cancelar" *ngIf="!esDetalle">{{
          "BTN_CANCELAR" | translate
        }}</a>
        <button
          icon="fa fa-floppy-o"
          label="{{ 'BTN_GUARDAR' | translate }}"
          type="submit"
          (click)="onSubmit()"
          pButton
        ></button>
      </div>
      <div class="col-12 md:col-12 lg:col-12 text-center" *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
        <span>{{ "LBL_GUARDANDO" | translate }}</span>
      </div>
    </div>

    <div class="grid form-footer-buttons" *ngIf="esDetalle">
      <div class="form-group col-12">
        <button
          icon="fa fa-arrow-left"
          label="{{ 'BTN_REGRESAR' | translate }}"
          type="button"
          pButton
          (click)="regresar(false)"
        ></button>
      </div>
    </div>
  </div>
</p-panel>

<p-confirmDialog #rt key="retanqueo">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="rt.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="rt.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cd key="oficinas">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

